import { MDText } from 'i18n-react';

import type { SellerStats } from 'Types/seller';
import { numberWithCommas } from 'Utilities/helpers';

import LocalTexts from './TradeSellerDetailsSection.texts.json';

type TradeDealerStat = { id: string; label: React.ReactNode; value: string };

const LocalT = new MDText(LocalTexts);

const TRANSACTIONS_THRESHOLD = 20;
const YEARS_THRESHOLD = 1;

export const getTradeSellerStatsConfig = ({
	dealerActiveYears,
	dealerCompanyActiveYears,
	numberOfDealerTransactions,
}: SellerStats): TradeDealerStat[] => {
	const moreThanOneYearCompanyActiveYears = dealerCompanyActiveYears >= YEARS_THRESHOLD;
	const moreThanOneYearActiveYears = dealerActiveYears >= YEARS_THRESHOLD;
	const moreThanTwentyTransactions = numberOfDealerTransactions > TRANSACTIONS_THRESHOLD;

	return [
		{
			id: 'dealerCompanyActiveYears',
			label: LocalT.translate('dealerCompanyActiveYears.label'),
			value: `${LocalT.translate(
				`dealerCompanyActiveYears.${moreThanOneYearCompanyActiveYears ? 'moreThanYearValue' : 'lessThanYearValue'}`,
				{ years: dealerCompanyActiveYears },
			)}`,
		},
		{
			id: 'dealerActiveYears',
			label: LocalT.translate('dealerActiveYears.label'),
			value: `${LocalT.translate(
				`dealerActiveYears.${moreThanOneYearActiveYears ? 'moreThanYearValue' : 'lessThanYearValue'}`,
				{ years: dealerActiveYears },
			)}`,
		},
		{
			id: 'numberOfDealerTransactions',
			label: LocalT.translate('numberOfDealerTransactions.label'),
			value: `${LocalT.translate(
				`numberOfDealerTransactions.${
					moreThanTwentyTransactions ? 'moreThanTwentyTransactions' : 'lessThanTwentyTransactions'
				}`,
				{
					transactions: numberWithCommas(numberOfDealerTransactions),
				},
			)}`,
		},
	];
};
